/**
 * Asginaciones de preguntas a periodo y boleta
 */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const OBTENER_VISITA_CAMPO_PREGUNTA = "obtenerVisitaCampoPregunta";
export const REGISTRAR_VISITA_CAMPO_PREGUNTA = "asignarVisitaCampoPregunta";


// mutation types
export const SET_VISITA_CAMPO_PREGUNTA = "setVisitaCampoPregunta";


const state = {
    visitaCampoPregunta:[],
     
}

const getters = {
    obtenervisitaCampoPreguntas(state) {
      return state.boletas;
    },
}

const actions = {

   
    /**
     * Obtener el mv de una visita de campo para una pregunta
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
    async [OBTENER_VISITA_CAMPO_PREGUNTA](context, datos) {
        let endpoint = `/api/VisitaCampo/${datos.boletaMuniId}/${datos.preguntaId}`;
       
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_VISITA_CAMPO_PREGUNTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     * Registrar un mv de visita de campo para una pregunta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [REGISTRAR_VISITA_CAMPO_PREGUNTA](context, datos){

        let endpoint=`api/VisitaCampo`;

        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_VISITA_CAMPO_PREGUNTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    




    
}

const mutations = {
    [SET_VISITA_CAMPO_PREGUNTA](state, data) {
        state.boletas = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}